import ClickOutside from 'vuetify/lib/directives/click-outside';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{def: ClickOutside,name:"click-outside",rawName:"v-click-outside",value:(_vm.close),expression:"close"}],class:_vm.styleClasses},[(_vm.active)?_c('div',[_vm._t("content")],2):_c('div',{on:{"click":_vm.open}},[_vm._t("display")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }